import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProviderState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: ProviderState = {
  data: [],
  isLoading: false,
  error: null,
};

const providerSlice = createSlice({
  name: 'providers',
  initialState,
  reducers: {
    setProviders: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setProviderLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setProviderError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setProviders, setProviderLoading, setProviderError } = providerSlice.actions;

export default providerSlice.reducer;
